import currency from 'currency.js'
import { centsToCurrency, formatCurrency } from '@/utils/currencyHelpers'

export const formatCurrencyWithDefault = (
  value: number | currency,
  shouldShow = true
) =>
  shouldShow
    ? formatCurrency(value, {
        hideDecimalsIfZero: true,
      })
    : '$-'

export const getProfitGoal = (
  incomeGoal: number | string | null | undefined,
  expenseRatio: number | string | null | undefined
) => {
  if (
    !incomeGoal ||
    !expenseRatio ||
    isNaN(Number(incomeGoal)) ||
    isNaN(Number(expenseRatio)) ||
    Number(expenseRatio) >= 1
  ) {
    return 0
  }
  return centsToCurrency(incomeGoal).multiply(1 - Number(expenseRatio)).value
}
